import React from 'react';
import { Minus, Check } from 'lucide-react';
export function ProblemSolution() {
  const problems = ['Sientes que te falta creatividad o técnica para hacer manualidades que realmente luzcan profesionales.', 'Has gastado dinero en materiales equivocados y tus piezas se rompen o agrietan.', 'Ves videos en internet pero te frustras porque omiten pasos clave y nunca te queda igual.', 'Quieres iniciar un emprendimiento desde casa pero no sabes qué producto es rentable y fácil de hacer.'];
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-257">
      <div className="container mx-auto px-4 relative z-10" data-id="element-258">
        <div className="max-w-3xl mx-auto" data-id="element-259">
          {/* Problem Section */}
          <div className="mb-24" data-id="element-260">
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-center mb-12 text-concrete-900" data-id="element-261">
              ¿Te resulta familiar alguna de estas situaciones?
            </h2>
            <div className="space-y-4" data-id="element-262">
              {problems.map((problem, index) => <div key={index} className="flex items-start gap-4 bg-sand-50 p-6 md:p-8 rounded-2xl border border-sand-100 transition-all hover:shadow-md" data-id="element-263">
                  <Minus className="w-5 h-5 text-terracotta-500 flex-shrink-0 mt-1" data-id="element-264" />
                  <p className="text-base md:text-lg text-concrete-700 font-light leading-relaxed" data-id="element-265">
                    {problem}
                  </p>
                </div>)}
            </div>
            <p className="text-center text-lg md:text-xl mt-12 font-medium text-concrete-800 italic" data-id="element-266">
              No es tu culpa. La mayoría de tutoriales gratuitos están
              incompletos.
            </p>
          </div>

          {/* Solution Section */}
          <div className="bg-sage-900 text-sand-50 rounded-[2.5rem] p-8 md:p-16 shadow-premium relative overflow-hidden" data-id="element-267">
            <div className="absolute top-0 right-0 w-64 h-64 bg-sage-800 organic-blob-1 blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2" data-id="element-268"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-gold-600/20 organic-blob-2 blur-2xl opacity-40 translate-y-1/3 -translate-x-1/4" data-id="element-269"></div>

            <div className="relative z-10" data-id="element-270">
              <span className="text-gold-400 text-xs font-bold tracking-widest uppercase mb-4 block" data-id="element-271">
                La Solución
              </span>
              <h2 className="font-heading text-3xl md:text-4xl font-semibold mb-6 text-balance text-white" data-id="element-272">
                El método definitivo para dominar el arte en cemento
              </h2>
              <p className="text-base md:text-lg text-sage-100 mb-10 font-light leading-relaxed" data-id="element-273">
                He creado un programa directo al grano, donde te revelo la
                fórmula exacta, las proporciones perfectas y los secretos de
                acabado para que tus piezas queden lisas, fuertes y hermosas
                desde el primer intento.
              </p>

              <ul className="space-y-5 mb-8" data-id="element-274">
                {['Fórmula probada anti-grietas', 'Materiales económicos y fáciles de conseguir', 'Paso a paso sin saltarse ningún detalle', 'Resultados profesionales en menos de 48 horas'].map((item, i) => <li key={i} className="flex items-center gap-4 text-sand-100" data-id="element-275">
                    <div className="w-6 h-6 rounded-full bg-terracotta-500/20 flex items-center justify-center flex-shrink-0" data-id="element-276">
                      <Check className="w-3.5 h-3.5 text-terracotta-400" data-id="element-277" />
                    </div>
                    <span className="text-base md:text-lg font-light" data-id="element-278">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}